import React from 'react'
import { Table } from 'react-bootstrap'

export default function(props){
    return <Table striped bordered hover>
    <thead>
      <tr>
        <th>Data</th>
        <th>Recompensa</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
        {
            props.rewards.map( reward => {
                return <tr>
                    <td>{ reward.created_at }</td>
                    <td>-{ reward.plan_discount_percents * 100 }%</td>
                    <td>{ reward.status }</td>
                </tr> })
        }
    </tbody>
  </Table>
}


// WEBPACK FOOTER //
// ./src/components/pages/afilliation/rewardHistory.jsx